import { render } from "./HouseTreeNode.vue?vue&type=template&id=6b89844e&scoped=true&ts=true"
import script from "./HouseTreeNode.vue?vue&type=script&lang=ts"
export * from "./HouseTreeNode.vue?vue&type=script&lang=ts"

import "./HouseTreeNode.vue?vue&type=style&index=0&id=6b89844e&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b89844e"]])

export default __exports__